var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.437,
    height: 8.208,
    viewBox: "0 0 16.437 8.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-ios-downward-outline",
    d: "M15.7,21.7a1.172,1.172,0,0,1-.75-.27l-7.032-5.86a1.173,1.173,0,0,1,1.5-1.8L15.7,19.02l6.282-5.063a1.2,1.2,0,1,1,1.488,1.887L16.442,21.5A1.172,1.172,0,0,1,15.7,21.7Z",
    transform: "translate(-7.498 -13.498)",
    fill: "rgba(255,255,255,0.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.ec4227086a362312e981fb4dc241a44c.svg";
export { ForwardRef as ReactComponent };